'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardTeamsCtrl', ['Authentication','departments', '$uibModal', '$state', 'teams', require('./dashboardTeamsCtrl')]);
app.directive('teams', [require('./dashboardTeamsDirective')]);
app.config(['$stateProvider', require('./dashboardTeamsConfig')]);
